<div class="page-contents">
  <div class="subBlockContainer">
    <div class="breadcrumbWrapper">
        <app-breadcrumb></app-breadcrumb>
    </div>
      <div class="subBlockContent">
          <child-header title="Qantas Rewards" (closeEvent)="navigateTo('/home')"></child-header>
          <div class="child-body">
            <div class="inner-subBlock-wrapper">
              <div class="page-title-wrapper">
                <div class="title blade-title-font">
                  Qantas <br/> Business Rewards
                </div>
                <!-- <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i> -->
              </div>
              <div><img class="img-rewards" src="../images/new_ui/qantas-rewards.png?id=1"></div>
              <div class="row">
                <div class="rewards-description">
                    SMB and mid-market reseller partners can now earn Qantas Points on eligible purchases with Dicker Data.
                </div>

                <a class="program-link" target="_blank" href="https://www.dickerdata.com.au/qantas-business-rewards">To find out more about the program click here</a>
              </div>
              <mat-spinner *ngIf="isLoading" mode="indeterminate" class="circle" diameter="20"></mat-spinner>
              <ng-container *ngIf="!isLoading">
                <div class="row" *ngIf="!showSuccess && !showError">
                  <mat-checkbox *ngIf="isRegistered" class="chb-rewards" [(ngModel)]="isRegistered" [disabled]="true">
                    Your account is registered for <br/> Qantas Business Rewards with <br/> ABN {{abnNumber}}
                  </mat-checkbox>
                  <span class="chb-rewards" style="margin-left: 45px;" *ngIf="!isRegistered">Your account is not registered for <br/> Qantas Business Rewards</span>
                </div>
    
                <div class="row" style="margin: auto;" *ngIf="!isRegistered && !showRegisterForm && !showError">
                  <button type="button" class="button button-red button-large btn-join"
                  (click)="this.showRegisterForm = true;">Join Qantas Business Rewards Now</button>
                </div>
    
              </ng-container>

              <div class="row" style="margin:auto" *ngIf="!isLoading && showRegisterForm">
                <ng-container [formGroup]="registerGroup">
                  <div class="register-form">
                    <mat-form-field [floatLabel]="'always'">
                      <input matInput formControlName="abnNumber" placeholder="ABN">
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'">
                      <mat-select class="titleValidate" placeholder="TITLE" formControlName="title" required>
                        <mat-option value="{{title}}" *ngFor="let title of titleList">{{title}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'">
                      <input matInput class="firstNameValidate" formControlName="firstName" placeholder="FIRST NAME"
                        required>
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'">
                      <input matInput class="lastNameValidate" formControlName="lastName" placeholder="LAST NAME"
                        required>
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'">
                      <input matInput class="emailAddressValidate" formControlName="emailAddress" placeholder="EMAIL ADDRESS">
                    </mat-form-field>
                    <mat-form-field [floatLabel]="'always'">
                      <input matInput type="number" class="mobileNumberValidate" formControlName="mobileNumber" placeholder="MOBILE NUMBER" required>
                      <span matPrefix>{{countryCode}} &nbsp;</span>
                    </mat-form-field>
                    <!-- <mat-form-field [floatLabel]="'always'">
                      <input matInput formControlName="promoCode" placeholder="PROMOTION CODE">
                    </mat-form-field> -->
                  </div>
                </ng-container>
                <button type="button" class="button button-red button-large btn-join"
                (click)="submitRegisterForm()">Submit</button>
              </div>

              <div class="row" *ngIf="showSuccess">
                  <div class="div-message">
                        <div class="message-title">
                          Success!
                        </div>
                        <div class="message-body">
                          Your account is now registered for <br/>
                          Qantas Business Rewards
                        </div>
                        <button type="button" class="button button-red button-large btn-message"
                        [routerLink]="['/home']">Return to Dashboard</button>
                  </div>
              </div>

              <div class="row" *ngIf="showError">
                <div class="div-message">
                  <div class="message-title">
                    Error
                  </div>
                  <div class="message-body">
                  {{qantasError}}
                  </div>
                  <button type="button" class="button button-red button-large btn-message"
                  (click)="returnToForm()">Return to Form</button>

                  <div id="bottom-navigation">
                    <button class="btnLink" [routerLink]="['/home']">Return to Dashboard</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>